import { Component } from '@angular/core';
import { LoaderService, LoaderStatus } from './loader.service';

@Component({
  selector: 'app-loader',
  template: `
    <div class="modelOverlay" *ngIf="loading"></div>
      <div class="loader" *ngIf="loading">
        <p-progressSpinner></p-progressSpinner>
      <div>{{message}}</div>
    </div>
  `,
  styles: [`
    .modelOverlay { position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: #DDDDDD; opacity: .8; z-index: 12000; }
    .loader { position: fixed; z-index: 13000; top: 30%; left: 50%; transform: translate(-50%, -50%);
      text-align: center; font-size: 15px; font-weight: bold; }
  `]
})
export class LoaderComponent {
  public loading = false;
  public message = 'Elaborazione in corso...';

  constructor(private loader: LoaderService) {
    this.loader.subscribe((s: LoaderStatus) => this.update(s));
  }

  private update(s: LoaderStatus) {
    this.loading = s.shown;
    if (s.hasMessage && s.message) {
      this.message = s.message;
    } else {
      this.message = 'Elaborazione in corso...';
    }
  }
}
